import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { P } from 'stile-shared/src/components/2020/common/Primitives';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Teaching Plan for Waves Unit"
      description="Conducted by Johns Hopkins University's Center for Research and Reform in Education"
      slug={props.location.pathname}
    />
  );
}

function TeachingGuidePage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Waves Unit Teaching Plan"
        subtitle="A teacher's sidekick to teaching Stile's Waves unit."
        id="TEACHING_GUIDE"
        redirectUrl="https://stileapp.com/go/us-teaching-plan"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/waves.jpg"
            alt="Waves Unit Teaching Plan"
          />
        }
      >
        <P>
          In this unit, students develop models of global telecommunication by investigating how a
          round-the-world video call works. To explain this phenomenon, students examine how sound
          and light waves transfer information to digital devices like smartphones. As they progress
          through the unit, they revise their models to reflect their growing understanding of sound
          and light energy.
        </P>
        <P>
          The Waves Teaching Plan also provides information about pre-requisite student knowledge, a
          guide to the assessments in the unit, and session-by-session lesson plans.
        </P>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default TeachingGuidePage;
